// Сделка закрыта TTL-джобой: заявка из мобильного приложения, банки не ответили за 2 часа
// (MobileAppCreditTtlExpiry). Снимается заменой машины — reassignCar.
export const DEAL_STATUS_TTL_EXPIRED = 24;
